import ReactGA from 'react-ga4'

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

export const initAnalytics = () => {
    if (!MEASUREMENT_ID) return
    ReactGA.initialize(MEASUREMENT_ID)
}

export const sendPageView = (path: string = location.pathname + location.search + location.hash) => {
    if (!MEASUREMENT_ID) return
    ReactGA.send({ hitType: 'pageview', page: path })
}

export const trackEvent = (event: string, params?: Record<string, string>) => {
    if (!MEASUREMENT_ID) return
    ReactGA.event(event, params)
}
